"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function PopularProductsConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="flex gap-4 overflow-hidden">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="w-full shrink-0 md:w-1/2 lg:w-1/4">
            <div className="mb-4 aspect-square animate-pulse rounded-lg bg-muted" />
            <div className="mb-2 h-4 w-3/4 animate-pulse rounded bg-muted" />
            <div className="h-4 w-1/2 animate-pulse rounded bg-muted" />
          </div>)}
      </div>;
  }
  if (error || !products?.length) {
    return null;
  }
  return <Carousel opts={{
    align: "start",
    loop: true
  }} className="w-full">
      <CarouselContent className="-ml-4">
        {products.map((product, index) => <CarouselItem key={product.id} data-index={index} className="pl-4 md:basis-1/2 lg:basis-1/4">
            <div className="group relative flex h-full flex-col">
              <Link to={product.link} className="flex-1">
                <div className="mb-4 aspect-square overflow-hidden rounded-lg bg-muted shadow-md backdrop-blur-sm">
                  {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-accent text-accent-foreground">
                      DialPad View
                    </div>}
                </div>
                <h3 className="font-default text-sm font-bold uppercase tracking-wider text-foreground line-clamp-1">
                  {product.title}
                </h3>
                {product.short_description && <div className="mt-2 font-serif text-sm text-muted-foreground line-clamp-2 [&>p]:mb-0" dangerouslySetInnerHTML={{
              __html: product.short_description
            }} />}
              </Link>
              <div className="mt-4">
                <AddToCartButton productId={product.id} variant="outline" className="w-full" buttonClassName="w-full bg-primary text-primary-foreground hover:bg-secondary transition-colors rounded-md" showQuantity={false} text="Explorar Interfaz" />
              </div>
            </div>
          </CarouselItem>)}
      </CarouselContent>
      <div className="mt-8 flex items-center justify-center gap-4">
        <CarouselPrevious className="static translate-y-0 border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-lg" />
        <CarouselNext className="static translate-y-0 border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-lg" />
      </div>
    </Carousel>;
}
export default function MsTeamsDialpadShowcase() {
  const wp_query_params = {
    per_page: 8,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="255598" id="ms-teams-dialpad-showcase" className="w-full bg-accent py-16 md:py-24 text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-10 text-center">
          
        </div>
        <EcommerceProductsProvider wp_query={{
        per_page: 8,
        orderby: "date",
        order: "desc"
      }}>
          <PopularProductsConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}